import { alias, API_URL, CapitalizeFirstWord, ROLE, isDashboardRole, isWebAttendanceBlocked } from "../../helpers/utils";
import axios from "../../helpers/axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import {
  decryptByText,
  getActiveRole,
  getDecryptedToken,
  requestPayloadBodyFormate,
  responseDataFormate,
  setEncryptedToken,
  setEncryptedUserData,
} from "../../helpers/bycrypt";
import { LoginResponse } from "../Types/response/login.interface";
import axiosInstance from "../../helpers/axios";
import { RedirectLoginPermissionArray } from "../../helpers/permissionModule";
import { message } from "antd";
import { Capacitor } from "@capacitor/core";
import { clearProductState } from "../../Admin/Reducer/productSlice";
import { isTimeVariant } from "../../helpers/appPackage";
interface LoginData {
  email: string;
  password: string;
  admin_panel: boolean;
  otp?: string;
  account_id?: string;
  time_app?: boolean;
  transform?: boolean;
  device_id?: string;
}
type DispatchAction = (action: {
  type: string;
  payload: { scope: string; status?: boolean | string | string[] };
}) => void;

type NavigateFunction = (path: string) => void;

const AUTH_URL = `${API_URL}`;

/**
 * User Login API Call Function
 * @param data - User Data Object containing email and password
 * @param navigate - Navigate Function to redirect user based on their role
 * @param setIsLoading - Function to set loading state
 * @returns A Redux Thunk Action
 */
export const LoginAPI =
  (
    data: LoginData,
    navigate: any,
    setIsLoading: (loading: boolean) => void,
    fromLocation: any,
  ) =>
    async (dispatch: (action: any) => void): Promise<any> => {
      if (setIsLoading) {
        setIsLoading(true);
      }

      dispatchLoading(dispatch, "auth", true);
      const isTime = await isTimeVariant();
      const payloadData = {
        ...data,
        time_app: isTime,
        transform: Capacitor.isNativePlatform() && !isTime,
      };
      const formatedData = requestPayloadBodyFormate(payloadData);
      try {
        const response = await axios.post(
          `${AUTH_URL}/auth/login`,
          formatedData,
          {
            withCredentials: true,
          },
        );

        let result: LoginResponse = responseDataFormate(response.data);

        if (result?.success) {
          if (result?.data?.otp_sent) {
            dispatchToast(dispatch, "success", result?.message);
            return result.data;
          }
          if (result?.message === "Multiple Accounts Found.") {
            return { multiple_accounts: true, accounts: result?.data?.accounts };
          }
          const originalRoles = Array.isArray(result?.data?.role) ? result.data.role : (result?.data?.role ? [result.data.role] : []);
          const activeRole = getActiveRole(result?.data?.role);

          console.log("calling activeRole", activeRole, "activeRole", activeRole);

          // ⛔ BLOCK: Attendance Tablet users can only clock in/out from the
          // native Capacitor apps (Android/iOS) which provide the camera
          // pipeline + local SQLite storage required by the face scanner.
          // On web browsers the role is allowed ONLY when
          // REACT_APP_ENABLE_WEB_ATTENDANCE=true (dev servers; defaults to
          // false when the variable is missing). Block BEFORE persisting any
          // session data.
          if (
            activeRole?.key === ROLE.ATTENDANCE_TABLET &&
            isWebAttendanceBlocked()
          ) {
            message.error("Clock in/out is not supported on web.");
            dispatchError(dispatch, "auth", undefined);
            return { blocked: true };
          }

          const payload: any = {
            ...result?.data,
            role: activeRole,
            roles: originalRoles,
            email: decryptByText(result?.data?.email),
            first_name: CapitalizeFirstWord(
              decryptByText(result?.data?.first_name),
            ),
            last_name: CapitalizeFirstWord(
              decryptByText(result?.data?.last_name),
            ),
            name: `${CapitalizeFirstWord(
              decryptByText(result?.data?.first_name),
            )} ${CapitalizeFirstWord(decryptByText(result?.data?.last_name))}`,
          };
          const { token, ...rest } = payload;
          // setEncryptedUserData(result?.data);
          setEncryptedToken(token);
          setEncryptedUserData(rest);

          localStorage.setItem("last_active_account", JSON.stringify({ email: payload.email, account_id: payload._id }));

          dispatch({
            type: "LOGIN_SUCCESS",
            payload: {
              ...payload,
            },
          });
          // dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "auth", undefined);
          const findRedirectPath =
            payload?.role?.key == ROLE.ADMIN
              ? RedirectLoginPermissionArray?.find((elem) => !elem?.disabled && (elem?.name !== "dashboard" || isDashboardRole(payload?.role || payload?.role?.key)))
              : RedirectLoginPermissionArray?.find(
                (ele: any) =>
                  !ele?.disabled &&
                  (ele?.name !== "dashboard" || isDashboardRole(payload?.role || payload?.role?.key)) &&
                  payload?.role?.permission?.some(
                    (per: any) => per?.name == ele?.name,
                  ),
              );
          if (activeRole?.key === ROLE.ATTENDANCE_TABLET) {
            navigate("/face-scanner");
          } else if (isTime) {
            navigate("/clock-in-history");
          } else if (!findRedirectPath?.path && payload?.role?.key != ROLE.ADMIN) {
            message.error(
              "Your role don't have any module permission. Please contact the administrator.",
            );
            const lastVisitedPage = localStorage.getItem(`lastVisitedPage_${payload?._id}`);
            localStorage.clear();
            if (lastVisitedPage) {
              localStorage.setItem(`lastVisitedPage_${payload?._id}`, lastVisitedPage);
            }
          } else {
            // Get User Role & Redirect user to respective home page
            const lastVisitedPage = localStorage.getItem(`lastVisitedPage_${payload?._id}`);
            let hasPermissionForLastPage = false;

            if (lastVisitedPage) {
              const matchingModule = RedirectLoginPermissionArray?.find((ele: any) => {
                return lastVisitedPage === ele.path || lastVisitedPage.startsWith(ele.path + '/') || lastVisitedPage.startsWith(ele.path + '?');
              });

              if (matchingModule) {
                if (!matchingModule.disabled &&
                  (matchingModule.name !== "dashboard" || isDashboardRole(payload?.role || payload?.role?.key))) {
                  hasPermissionForLastPage = payload?.role?.key === ROLE.ADMIN || payload?.role?.permission?.some((per: any) => per?.name === matchingModule.name);
                }
              } else {
                hasPermissionForLastPage = true;
              }
            }

            if (lastVisitedPage && hasPermissionForLastPage) {
              navigate(lastVisitedPage, { replace: true });
            } else if (fromLocation) {
              const findModuleName = RedirectLoginPermissionArray?.find(
                (ele: any) => !ele?.disabled && fromLocation?.includes(ele?.path),
              );
              if (findModuleName) {
                const findPermission =
                  payload?.role?.key == ROLE?.ADMIN
                    ? true
                    : payload?.role?.permission?.find(
                      (el: any) => el?.name == findModuleName?.name,
                    );
                if (findPermission) {
                  navigate(fromLocation, { replace: true });
                } else {
                  navigate(findRedirectPath?.path);
                }
              } else {
                navigate(findRedirectPath?.path);
              }
            } else {
              navigate(findRedirectPath?.path);
            }
          }
        } else {
          elseHandler(dispatch, "auth", result);
        }
      } catch (error: any) {
        if (error?.response?.status === 406) {
          let serverData: any = null;
          try {
            serverData = responseDataFormate(error?.response?.data);
          } catch (e) { }
          const serverMessage =
            serverData?.message ||
            serverData?.msg ||
            error?.response?.data?.message ||
            error?.response?.data?.msg;

          const isTime = await isTimeVariant();
          const targetApp = isTime ? "Transform" : "Time";
          const message = `Your account does not have access to this app. Please use the <b>${targetApp}</b> app to continue.`;

          dispatchError(dispatch, "auth", undefined);
          return {
            blocked: true,
            status: 406,
            title: "This App Is Not Available for You",
            message: message,
          };
        }
        catchHandler(dispatch, "auth")(error);
      } finally {
        localStorage.removeItem("logout");
        dispatchLoading(dispatch, "auth", false);
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    };

export const SwitchLoginAPI =
  (
    data: any,
    navigate: any,
    setIsLoading?: (loading: boolean) => void,
    fromLocation?: any,
  ) =>
    async (dispatch: (action: any) => void): Promise<any> => {
      if (setIsLoading) {
        setIsLoading(true);
      }

      dispatchLoading(dispatch, "auth", true);
      const isTime = await isTimeVariant();
      const payloadData = {
        ...data,
        time_app: isTime,
        transform: Capacitor.isNativePlatform() && !isTime,
      };
      const formatedData = requestPayloadBodyFormate(payloadData);
      try {
        const response = await axiosInstance.post(
          `${AUTH_URL}/auth/switch-login`,
          formatedData,
          {
            withCredentials: true,
          },
        );

        let result: LoginResponse = responseDataFormate(response.data);

        if (result?.success) {
          const originalRoles = Array.isArray(result?.data?.role) ? result.data.role : (result?.data?.role ? [result.data.role] : []);
          const activeRole = getActiveRole(result?.data?.role);

          // ⛔ BLOCK: Attendance Tablet users can only clock in/out from the
          // native Capacitor apps (Android/iOS). On web browsers the role is
          // allowed ONLY when REACT_APP_ENABLE_WEB_ATTENDANCE=true (dev
          // servers; defaults to false). Block BEFORE persisting any session
          // data.
          if (
            activeRole?.key === ROLE.ATTENDANCE_TABLET &&
            isWebAttendanceBlocked()
          ) {
            message.error("Clock in/out is not supported on web.");
            dispatchError(dispatch, "auth", undefined);
            return { blocked: true };
          }

          const payload: any = {
            ...result?.data,
            role: activeRole,
            roles: originalRoles,
            email: decryptByText(result?.data?.email),
            first_name: CapitalizeFirstWord(
              decryptByText(result?.data?.first_name),
            ),
            last_name: CapitalizeFirstWord(
              decryptByText(result?.data?.last_name),
            ),
            name: `${CapitalizeFirstWord(
              decryptByText(result?.data?.first_name),
            )} ${CapitalizeFirstWord(decryptByText(result?.data?.last_name))}`,
          };
          const { token, ...rest } = payload;

          setEncryptedToken(token);
          setEncryptedUserData(rest);

          localStorage.setItem("last_active_account", JSON.stringify({ email: payload.email, account_id: payload._id }));

          dispatch({
            type: "LOGIN_SUCCESS",
            payload: {
              ...payload,
            },
          });

          dispatchError(dispatch, "auth", undefined);
          const findRedirectPath =
            payload?.role?.key == ROLE.ADMIN
              ? RedirectLoginPermissionArray?.find((elem) => !elem?.disabled && (elem?.name !== "dashboard" || isDashboardRole(payload?.role || payload?.role?.key)))
              : RedirectLoginPermissionArray?.find(
                (ele: any) =>
                  !ele?.disabled &&
                  (ele?.name !== "dashboard" || isDashboardRole(payload?.role || payload?.role?.key)) &&
                  payload?.role?.permission?.some(
                    (per: any) => per?.name == ele?.name,
                  ),
              );

          const isTime = await isTimeVariant();
          if (activeRole?.key === ROLE.ATTENDANCE_TABLET) {
            navigate("/face-scanner");
          } else if (isTime) {
            navigate("/clock-in-history");
          } else if (!findRedirectPath?.path && payload?.role?.key != ROLE.ADMIN) {
            message.error(
              "Your role don't have any module permission. Please contact the administrator.",
            );
            const lastVisitedPage = localStorage.getItem(`lastVisitedPage_${payload?._id}`);
            localStorage.clear();
            if (lastVisitedPage) {
              localStorage.setItem(`lastVisitedPage_${payload?._id}`, lastVisitedPage);
            }
          } else {
            const lastVisitedPage = localStorage.getItem(`lastVisitedPage_${payload?._id}`);
            let hasPermissionForLastPage = false;

            if (lastVisitedPage) {
              const matchingModule = RedirectLoginPermissionArray?.find((ele: any) => {
                return lastVisitedPage === ele.path || lastVisitedPage.startsWith(ele.path + '/') || lastVisitedPage.startsWith(ele.path + '?');
              });

              if (matchingModule) {
                if (!matchingModule.disabled &&
                  (matchingModule.name !== "dashboard" || isDashboardRole(payload?.role || payload?.role?.key))) {
                  hasPermissionForLastPage = payload?.role?.key === ROLE.ADMIN || payload?.role?.permission?.some((per: any) => per?.name === matchingModule.name);
                }
              } else {
                hasPermissionForLastPage = true;
              }
            }

            if (lastVisitedPage && hasPermissionForLastPage) {
              navigate(lastVisitedPage, { replace: true });
            } else if (fromLocation) {
              const findModuleName = RedirectLoginPermissionArray?.find(
                (ele: any) => !ele?.disabled && fromLocation?.includes(ele?.path),
              );
              if (findModuleName) {
                const findPermission =
                  payload?.role?.key == ROLE?.ADMIN
                    ? true
                    : payload?.role?.permission?.find(
                      (el: any) => el?.name == findModuleName?.name,
                    );
                if (findPermission) {
                  navigate(fromLocation, { replace: true });
                } else {
                  navigate(findRedirectPath?.path);
                }
              } else {
                navigate(findRedirectPath?.path);
              }
            } else {
              navigate(findRedirectPath?.path);
            }
          }
          return result; // return success
        } else {
          elseHandler(dispatch, "auth", result);
        }
      } catch (error: any) {
        if (error?.response?.status === 406) {
          let serverData: any = null;
          try {
            serverData = responseDataFormate(error?.response?.data);
          } catch (e) { }
          const serverMessage =
            serverData?.message ||
            serverData?.msg ||
            error?.response?.data?.message ||
            error?.response?.data?.msg;

          const isTime = await isTimeVariant();
          const targetApp = isTime ? "Transform" : "Time";
          const message = `Your account does not have access to this app. Please use the <b>${targetApp}</b> app to continue.`;

          dispatchError(dispatch, "auth", undefined);
          return {
            blocked: true,
            status: 406,
            title: "This App Is Not Available for You",
            message: message,
          };
        }
        catchHandler(dispatch, "auth")(error);
      } finally {
        dispatchLoading(dispatch, "auth", false);
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    };

export const ResendLoginOtpAPI =
  (
    data: any,
    setIsLoading: (loading: boolean) => void,
  ) =>
    async (dispatch: (action: any) => void): Promise<any> => {
      if (setIsLoading) {
        setIsLoading(true);
      }
      dispatchLoading(dispatch, "auth", true);
      const isTime = await isTimeVariant();
      const payloadData = {
        ...data,
        time_app: isTime,
        transform: !isTime,
      };
      const formatedData = requestPayloadBodyFormate(payloadData);
      try {
        const response = await axios.post(
          `${AUTH_URL}/auth/resend-login-otp`,
          formatedData,
          {
            withCredentials: true,
          },
        );

        let result: LoginResponse = responseDataFormate(response.data);

        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          return result.data;
        } else {
          elseHandler(dispatch, "auth", result);
        }
      } catch (error) {
        catchHandler(dispatch, "auth")(error);
      } finally {
        if (setIsLoading) {
          setIsLoading(false);
        }
        dispatchLoading(dispatch, "auth", false);
      }
    };
/**
 *
 * @param data
 * @param setLinkSent
 * @param setEmail
 * @param setIsLoading
 * @returns
 */
export const ForgotPasswordAPI =
  (
    data: any,
    setLinkSent: (link: boolean) => void,
    setEmail: (email: string) => void,
    setIsLoading: (loading: boolean) => void,
  ) =>
    async (dispatch: (action: any) => void) => {
      dispatchLoading(dispatch, "auth", true);

      try {
        const isTime = await isTimeVariant();
        const payloadWithVariant = {
          ...data,
          time_app: isTime,
          transform: !isTime,
        };

        const response = await axios.post(
          `${API_URL}/auth/forgot-password`,
          payloadWithVariant,
        );
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "auth", undefined);
          setLinkSent(true);
          setEmail(data?.email);
          return result;
        } else {
          elseHandler(dispatch, "auth", result);
          return result;
        }
      } catch (error: any) {
        if (error?.response?.status === 406) {
          let serverData: any = null;
          try {
            serverData = responseDataFormate(error?.response?.data);
          } catch (e) { }
          const serverMessage =
            serverData?.message ||
            serverData?.msg ||
            error?.response?.data?.message ||
            error?.response?.data?.msg;

          const isTime = await isTimeVariant();
          const targetApp = isTime ? "Transform" : "Time";
          const message = `Your account does not have access to this app. Please use the <b>${targetApp}</b> app to continue.`;

          dispatchError(dispatch, "auth", undefined);
          return {
            blocked: true,
            status: 406,
            title: "This App Is Not Available for You",
            message: message,
          };
        }
        catchHandler(dispatch, "auth")(error);
      } finally {
        if (setIsLoading) {
          setIsLoading(false);
        }
        dispatchLoading(dispatch, "auth", false);
      }
    };

/**
 * Get User Uprights API
 *
 * @param {Function} navigate Function to navigate user
 * @returns {}
 */

let inFlightProfilePromise: Promise<any> | null = null;
let lastProfileFetchTime = 0;

export const GetProfileAPI =
  (navigate: any, newLocationState?: any, year?: number, isSilent = false, force = false) =>
    async (dispatch: (action: any) => void) => {
      if (inFlightProfilePromise) {
        return inFlightProfilePromise;
      }
      if (!force && Date.now() - lastProfileFetchTime < 1500) {
        return;
      }

      if (!isSilent) dispatchLoading(dispatch, "auth", true);
      inFlightProfilePromise = axiosInstance
        .get(`/auth/profile`, {
          params: year ? { year } : undefined,
        })
        .then((response) => {
          let result = responseDataFormate(response.data);
          if (result?.success) {
            const originalRoles = Array.isArray(result?.data?.role) ? result.data.role : (result?.data?.role ? [result.data.role] : []);
            const activeRole = getActiveRole(result?.data?.role);

            // ⛔ BLOCK: Attendance Tablet sessions are only valid inside the
            // native Capacitor apps — unless REACT_APP_ENABLE_WEB_ATTENDANCE=true
            // (dev servers; defaults to false) allows them on web. If a profile
            // load resolves to the attendance-tablet role on a blocked web
            // browser (e.g. a stale saved default role), end the session
            // cleanly with the standard error instead of trapping the user on
            // the face-scanner page.
            if (
              activeRole?.key === ROLE.ATTENDANCE_TABLET &&
              isWebAttendanceBlocked()
            ) {
              message.error("Clock in/out is not supported on web.");
              dispatch({ type: "AUTH_LOAD_FAILURE" });
              localStorage.clear();
              if (!isSilent) dispatchLoading(dispatch, "auth", false);
              navigate("/login");
              return;
            }

            const payload: any = {
              ...result?.data,
              role: activeRole,
              roles: originalRoles,
              email: decryptByText(result?.data?.email),
              // name: CapitalizeFirstWord(decryptByText(result?.data?.name)),
              first_name: CapitalizeFirstWord(
                decryptByText(result?.data?.first_name),
              ),
              last_name: CapitalizeFirstWord(
                decryptByText(result?.data?.last_name),
              ),
              name: `${CapitalizeFirstWord(
                decryptByText(result?.data?.first_name),
              )} ${CapitalizeFirstWord(decryptByText(result?.data?.last_name))}`,
            };
            // console.log('payload',payload);
            setEncryptedUserData(payload);
            dispatch({
              type: "AUTH_LOAD_SUCCESS",
              payload: {
                ...payload,
              },
            });

            dispatchError(dispatch, "auth", undefined);
          } else {
            dispatch({ type: "AUTH_LOAD_FAILURE" });
            elseHandler(dispatch, "auth", result);
            localStorage.clear();
            if (newLocationState) {
              localStorage.removeItem("logout");
              navigate("/login", newLocationState);
            } else {
              navigate("/login");
            }
          }
          if (!isSilent) dispatchLoading(dispatch, "auth", false);
        })
        .catch((err) => {
          if (err?.code != "ERR_CANCELED") {
            if (!isSilent) dispatchLoading(dispatch, "auth", false);
            const status = err?.response?.status;

            if (status === 401 || status === 444) {
              dispatch({ type: "AUTH_LOAD_FAILURE" });
              localStorage.clear();
              if (newLocationState) {
                navigate("/login", newLocationState);
              } else {
                navigate("/login");
              }
            } else {
              // For Network Errors (500) or other errors, don't clear localStorage.
              if (err?.code === "ERR_NETWORK" || status === 500) {
                if (!isSilent) dispatchToast(dispatch, "error", "Unable to connect to server");
              } else {
                const errMsg = err?.response?.data?.message || err?.message || "Unable to fetch profile";
                if (!isSilent) dispatchToast(dispatch, "error", errMsg);
              }
            }
          }
        })
        .finally(() => {
          inFlightProfilePromise = null;
          lastProfileFetchTime = Date.now();
        });

      return inFlightProfilePromise;
    };
/**
 * Logout
 *
 * @param data
 * @param navigate
 * @returns
 */
export const LogoutAPI =
  (data: any, navigate: NavigateFunction) =>
    async (dispatch: (action: any) => void) => {
      dispatchLoading(dispatch, "auth", true);
      const isTime = await isTimeVariant();
      const logoutData = Capacitor.isNativePlatform()
        ? {
          ...data,
          token: getDecryptedToken(),
          time_app: isTime,
          transform: !isTime,
        }
        : data;

      const performClientLogout = () => {
        dispatchError(dispatch, "auth", undefined);
        dispatch({ type: "LOGOUT_SUCCESS" });
        localStorage.clear();
        dispatch(clearProductState());
        localStorage.setItem("logout", "true");
        dispatchLoading(dispatch, "auth", false);
        navigate("/login");
      };

      axios
        .post(`${AUTH_URL}/auth/logout`, logoutData, { withCredentials: true })
        .then((response) => {
          let result = responseDataFormate(response.data);
          if (result?.success) {
            dispatchToast(dispatch, "success", result?.message);
          }
          performClientLogout();
        })
        .catch((err) => {
          console.warn("Logout API failed, completing local logout anyway:", err);
          performClientLogout();
        });
    };

export const UpdateProfileAPI =
  (data: any, navigate: any, setIsEdit: any, onSuccess?: () => void) =>
    async (dispatch: (action: any) => void) => {
      dispatchLoading(dispatch, "editProfile", true);
      const formatedData = requestPayloadBodyFormate(data);
      axios
        .put(`${AUTH_URL}/auth/profile`, formatedData, { withCredentials: true })
        .then((response) => {
          let result = responseDataFormate(response.data);
          if (result?.success) {
            if (onSuccess) onSuccess();
            setIsEdit(false);
            navigate("/profile");
            dispatch(GetProfileAPI(navigate));
            dispatchToast(dispatch, "success", result?.message);
            dispatchError(dispatch, "editProfile", undefined);
          } else elseHandler(dispatch, "editProfile", result);
          dispatchLoading(dispatch, "editProfile", false);
        })
        .catch(catchHandler(dispatch, "editProfile"));
    };

// { oldPassword: string; newPassword: string }
export const UpdatePasswordAPI =
  (data: any, navigate: any) => async (dispatch: (action: any) => void): Promise<any> => {
    dispatchLoading(dispatch, "changePassword", true);
    const formatedData = requestPayloadBodyFormate(data);
    try {
      const response = await axios.put(`${AUTH_URL}/auth/change-password`, formatedData, {
        withCredentials: true,
      });
      let result = responseDataFormate(response.data);
      if (result?.success) {
        if (result?.data?.otp_sent) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "changePassword", undefined);
          return result.data;
        }
        navigate(-1);
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "changePassword", undefined);
      } else {
        elseHandler(dispatch, "changePassword", result);
      }
    } catch (error) {
      catchHandler(dispatch, "changePassword")(error);
    } finally {
      dispatchLoading(dispatch, "changePassword", false);
    }
  };

export const ResendChangePasswordOtpAPI =
  (data: any) => async (dispatch: (action: any) => void): Promise<any> => {
    dispatchLoading(dispatch, "changePassword", true);
    const formatedData = requestPayloadBodyFormate(data);
    try {
      const response = await axios.put(`${AUTH_URL}/auth/resend-change-password-otp`, formatedData, {
        withCredentials: true,
      });
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        return result.data;
      } else {
        elseHandler(dispatch, "changePassword", result);
      }
    } catch (error) {
      catchHandler(dispatch, "changePassword")(error);
    } finally {
      dispatchLoading(dispatch, "changePassword", false);
    }
  };

export const ResetPasswordAPI =
  (data: any, navigate: NavigateFunction) =>
    (dispatch: (action: any) => void) => {
      dispatchLoading(dispatch, "auth", true);
      axios
        .put(`${API_URL}/auth/reset-password`, data)
        .then((response) => {
          let result = responseDataFormate(response.data);
          if (result?.success) {
            dispatchToast(dispatch, "success", result?.message);
            dispatchError(dispatch, "auth", undefined);
            navigate("/login");
          } else elseHandler(dispatch, "auth", result);
          dispatchLoading(dispatch, "auth", false);
        })
        .catch(catchHandler(dispatch, "auth"));
    };

// Register FCM Token API
export const RegisterFCMTokenAPI =
  (fcmToken: string) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "fcm", true);

    try {
      const isTime = await isTimeVariant();
      const response = await axiosInstance.post(
        "/auth/fcm",
        { fcm: fcmToken, device: Capacitor.isNativePlatform() ? "app" : "web", time_app: isTime },
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );

      const result = responseDataFormate(response.data);

      if (result?.success) {
        dispatch({
          type: "FCM_REGISTER_SUCCESS",
          payload: true,
        });

        console.log("✅ FCM Token registered successfully");
      } else {
        dispatch({
          type: "FCM_REGISTER_FAILURE",
        });

        elseHandler(dispatch, "fcm", result);
      }
    } catch (error) {
      dispatch({
        type: "FCM_REGISTER_FAILURE",
      });
      catchHandler(dispatch, "fcm")(error);
    } finally {
      dispatchLoading(dispatch, "fcm", false);
    }
  };
